<template lang="pug">
  .page-login
    header.page-login__header.app-header
      .app-header__wrapper
        .app-header__logo
          a(href='/').app-header__logo-link PROFEED PLANT
        .app-header__profile-wrap
          v-dropdown(
                ref="dropdown"
                width-auto
                position-right)
                v-btn(icon)
                  font-awesome-icon(
                    size="xs"
                    icon="ellipsis-v")
                v-card(
                  elevated
                  slot="content")
                    .app-settings
                      h3.app-settings__title {{ 'base.language' | translate }}
                      .app-settings__section
                        lang-switcher

    .page-login__auth
      .page-login__auth-wrap
        h2.page-login__auth-title PROFEED PLANT
        p.page-login__auth-desc {{ 'pages.reset_password.title' | translate }}
        form.page-login__auth-form(@submit.prevent="send")
          .page-login__auth-group
            input(
              type='password'
              :placeholder="$t('base.new_password')"
              v-model="form.password").input-field
          .page-login__auth-group
            input(
              type='password'
              :placeholder="$t('base.repeat_password')"
              v-model="form.password_confirmation").input-field
          v-btn.page-login__auth-btn(
            :loading="loading") {{ 'actions.save' | translate }}
          transition(name="fadex")
            .page-login__auth-alert(v-if="error")
              i.page-login__auth-icon.i-error
              p.page-login__auth-error {{ error }}
    .page-login__promo
      h1.page-login__promo-title {{ 'pages.login.intro' | translate }}
      p.page-login__promo-desc {{ 'pages.login.description' | translate }}
    footer.page-login__footer
      p.page-login__footer-copy © Profeed Plant 2022

</template>

<script>
import LangSwitcher from '@/components/layouts/header/app-settings/LangSwitcher.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import { getRouteRedirect } from '@/util/utils'

export default {
  name: 'ResetPassword',

  components: {
    LangSwitcher
  },

  data: () => ({
    form: {
      password: null,
      password_confirmation: null
    },
    error: null,
    loading: false
  }),

  computed: {
    ...mapGetters(['user'])
  },

  mounted () {
    if (this.user && this.user.token) {
      this.$router.push(getRouteRedirect(this.user.user.role, '/farm'))
    }
  },

  methods: {
    send () {
      api.auth.resetPassword(this.$route.fullPath, this.form)
        .then(response => {
          if (!response.error) {
            this.$router.push('/login')
          }

          this.$toasted.show(response.data.error, {
            position: 'bottom-center',
            duration: 5000
          })
          for (const key in response.data.errors) {
            this.$toasted.show(response.data.errors[key], {
              position: 'bottom-center',
              duration: 5000
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.app-settings {
  padding: 2rem;
  min-width: 19rem;

  &__title {
    font-size: 1.5rem;
    line-height: 1.8rem;
    font-weight: 500;
    color: $color-gray;
    margin-bottom: 1.5rem;
  }

  &__section {
    position: relative;
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid $color-gray-light-2;
  }

  &__btn-icon {
    font-size: 1.8rem;
    margin-right: 1.3rem;
  }

  &__btn-text {
    font-size: 1.6rem;
    line-height: 1.8rem;
  }
}
</style>
